import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

const RADIUS        = 15;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

@Component({
  selector: 'app-progress-ring',
  standalone: true,
  template: `
    <svg viewBox="0 0 40 40" role="img" [attr.aria-label]="rounded() + '%'">
      <circle class="track" cx="20" cy="20" [attr.r]="radius" />
      <circle
        class="fill"
        cx="20"
        cy="20"
        [attr.r]="radius"
        [attr.stroke-dasharray]="circumference"
        [attr.stroke-dashoffset]="dashOffset()" />
    </svg>
  `,
  styles: [`
    :host {
      display: inline-flex;
      width:   var(--ring-size, 2.5rem);
      height:  var(--ring-size, 2.5rem);
    }
    svg { width: 100%; height: 100%; transform: rotate(-90deg); }
    circle { fill: none; stroke-width: 7; }
    .track {
      fill:   var(--ring-center, #ffffff);
      stroke: var(--ring-track, #D9CCE8);
    }
    .fill {
      stroke:         var(--ring-color, #8661AE);
      stroke-linecap: butt;
      transition:     stroke-dashoffset 0.3s ease;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressRingComponent {
  readonly percent = input<number>(0);

  protected readonly radius        = RADIUS;
  protected readonly circumference = CIRCUMFERENCE;

  protected readonly rounded = computed(() => Math.round(this.percent()));

  /** Longueur de trait masquée : le pourcentage est borné à [0, 100]. */
  protected readonly dashOffset = computed(() => {
    const clamped = Math.min(Math.max(this.percent(), 0), 100);
    return CIRCUMFERENCE * (1 - clamped / 100);
  });
}
